<template>
    <div class="ElectricityStatistics">
        <Title firstName="发电量统计" lastName="ELECTRICITY GENERATION STATISTICS"/>
        <div class="echarts">
            <div class="edata">
                <div class="edataCon">
                    <p>本月发电</p>
                    <p>{{allPower}}<span> kWh</span></p>
                </div>
                <!-- <div class="sevenDay" >近七日发电</div> -->
            </div>
            <div class="eview">
                <Bar :chartId="chartId" :seriesData="seriesData" :xData="xData" unit="kWh" v-if="seriesData.length >0"/>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../components/title/Title.vue')
const Bar = () => import('../../../components/echarts/bar.vue')

import { getSevenDays } from '../../../utils/common'
import { mapState } from 'vuex'

export default {
    props:["areaId"],
    data(){
        return {
            chartId:'generAll',
            xData:[],
            seriesData:[],
            arr:[],
            loops:[]
        }
    },
    components:{
        Title,Bar
    },
    computed:{
        ...mapState({mqtt:'MQTTObj'}),
        fadianTotal(){
            let sumFadian = 0
            this.seriesData.forEach(item =>{
                sumFadian += item
            })
            return sumFadian
        },
        weather(){
            return this.$store.state.Cang.weather
        },
        allPower(){
            let sum = 0
            this.loops.forEach(item =>{
                sum += isNaN(Number(this.mqtt[item.subLoopUrl +'/Monthly_Power_Generation']).toFixed(2))? 0 :Number(this.mqtt[item.subLoopUrl +'/Monthly_Power_Generation'])
            })
            return sum.toFixed(2)
        } 
    },
    mounted(){
        if(this.areaId){
            this.getinverter()
            this.getWeekData()
        }
        
    },
    methods:{
        // 获取最近7天的日期
        async getWeekData(){
            let sevenDays = getSevenDays()

            let keys = Object.values(sevenDays)
            this.xData =  keys.reverse().map(item =>{
                return item = item.substr(5)
            })
            let data = {
                start : `${sevenDays.seven}T00:00:00Z`,
                end : `${sevenDays.one}T24:00:00Z`,
                areaId:this.areaId
            }
            let res = await this.$http.getdailyPowerInverterarea(data)
            // console.log(res);
            this.seriesData = res.data.data.points.map(item => item = Number(item).toFixed(2))

        },
        async getinverter(){
            let data = {
                areaId :this.areaId
            }
            let res = await this.$http.getinverterarea(data)
            console.log(res);
            this.loops = res.data.data.loops
        }
    },
    
    
}
</script>

<style lang="less" scoped>
    .ElectricityStatistics{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 64.4vh;
        left: 2vw;

        .echarts{
            position: relative;
            height: 28.7vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                height: 9vh;
                display: flex;
                justify-content: space-around;
                padding: 3vh 0;
                .edataCon{
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                }

                .sevenDay{
                    font-size: 12rem;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(230,243,253, 0.7);
                    position: absolute;
                    right: 1vw;
                    top: 6.5vh;
                }
            }

            .eview{
                width: 100%;
                padding: 0 0.5vw;
                height: 17.9vh;
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>